module.exports = __webpack_public_path__ + "static/avatar-fb2e8aabd87a0514720c3eb0c564193e.png";